// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import checkCircleFilledIcon from "@/assets/icons/aop/check-circle-filled.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CheckCircleFilledIconProps = Omit<IconProps, "name">;

export function CheckCircleFilledIcon(props: CheckCircleFilledIconProps): React.ReactNode {
  return <Icon name={checkCircleFilledIcon} {...props} />;
}
